var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebsite = function SvgWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".website_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.5a6.98 6.98 0 0 0 1.5-4M15 22.5a6.98 6.98 0 0 1-1.5-4M7.499 22.5h9M.5 15.5h23",
    className: "website_svg__a"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 17,
    x: 0.5,
    y: 1.5,
    className: "website_svg__a",
    rx: 1,
    ry: 1
  })));
};
export default SvgWebsite;